import intlTelInput from "intl-tel-input/intlTelInputWithUtils";

export const getDialCodeByCountryCode = (
  countryCode: string,
): string | undefined => {
  return intlTelInput
    .getCountryData()
    .find((c) => c.iso2 === countryCode.toLowerCase())?.dialCode;
};
